export default "__VITE_ASSET__D3m_ZNXu__"